<template>
    <div class="popup">
        <div class="popup-content">
            <img src="/img/close-btn.svg" class="modal__close" @click="closePopup" />
            <div class="popup-text">
                <div class="popup-title">
                    <i18n-t keypath="dashboard.manualTransferInfo.title" />
                </div>
                <div class="popup-description">
                    <i18n-t
                        keypath="dashboard.manualTransferInfo.manualTransferDescription"
                    />
                </div>
            </div>
            <div class="button-container">
                <button class="button-text back-button" @click="goBack">
                    <i18n-t
                        keypath="common.confirm"
                    />
                </button>
                <button class="button-text confirm-button" @click="confirm">
                    <i18n-t
                        keypath="common.back"
                    />
                </button>
            </div>
        </div>
    </div>
</template>

<style scoped>
.popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.popup-content {
    position: relative;
    width: 440px;
    height: 256px;
    padding: 20px;
    background-color: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    box-sizing: border-box;
}

.popup-text {
    text-align: center;
    margin-top: 40px;
}

.popup-title {
    font-size: 24px;
    font-weight: 500;
    line-height: 30px;
    text-align: center;
    color: rgba(40, 55, 71, 1);
}

.popup-description {
    font-size: 13px;
    font-weight: 400;
    line-height: 19.5px;
    text-align: center;
    color: rgba(98, 118, 144, 1);
    margin-top: 5px;
    width: 314px;
    height: 80px;
    margin-left: 10%;
}

.button-container {
    width: calc(100% + 40px);
    margin-left: -20px;
    display: flex;
    justify-content: center;
    padding-top: 10px;
    border-top: 1px solid rgba(228, 234, 240, 1);
    margin-top: auto;
}

.button-container button {
    width: 116px;
    height: 40px;
    font-size: 14px;
    font-weight: 600;
    line-height: 21px;
    text-align: center;
    text-transform: uppercase;
    border-radius: 4px;
    cursor: pointer;
    border: 1px solid rgba(26, 160, 225, 1);
}

.back-button {
    margin-right: 70px;
    color: rgba(26, 160, 225, 1);
    background: none;
}

.confirm-button {
    margin-left: 70px;
    color: white;
    background: rgba(26, 160, 225, 1);
}

.back-button:hover,
.confirm-button:hover {
    transform: scale(1.05);
}
</style>

<script lang="ts">
import { ManualTransferConfirmPopup } from "@/dashboard/my-orders/new-popup/manual-transfer-confirm-popup/manual-transfer-confirm-popup";

export default ManualTransferConfirmPopup;
</script>
